import { LiveAgentsGate, requireLiveAgentsEnabled } from "~/components/live-agents-gate";
import { createFileRoute } from "@tanstack/react-router";
import { LiveAgentsPage } from "~/pages/LiveAgentsPage";

export const Route = createFileRoute("/_dashboard/$datasetSlug/settings/live-agents")({
  beforeLoad: requireLiveAgentsEnabled,
  component: () => (
    <LiveAgentsGate>
      <LiveAgentsPage />
    </LiveAgentsGate>
  ),
});
